module.exports = __webpack_public_path__ + "pc/img/ic_plus.c7b1ca70.svg";